export enum SearchItemCardRenderType {
  button = "button",
  link = "link",
}
